export const MUNILY_FILE_DROP_UPLOADER_DEFAULTS = {
  acceptedFormats: '.jpeg,.jpg,.png,.pdf',
  maxSizeInBytes: 10 * 1024 * 1024,
  maxSizeText: '10MB',
  multiple: false,
  disabled: false,
} as const;

export type MunilyFileDropUploaderFileIcon = 'image' | 'pdf' | 'draft';
